
<template>
  <div class="quick-links-widget">
    <template v-for="item in linksVisible">
      <div
        v-if="renderComponent"
        :key="item.id"
        class="fast-link"
      >
        <div
          v-if="item.icon"
          class="fast-link__icon"
        >
          <svg-loader
            :id="item.id"
            class="icon-quick-links"
            :src="'/static/images/icon-dashboard-' + item.icon + '.svg'"
          />
        </div>
        <div
          class="fast-link__item"
          :class="{'fast-link__description--bigger': item.sizeBig} "
          @click="go(item.action)"
        >
          <h2 :id="item.id">
            {{ item.text }}
          </h2>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { DASHBOARD_FAST_LINKS, eventBus } from '@/api/eventbus'

export default {
  name: 'QuickLinks',
  props: {
    content: {
      icon: {
        type: String
      },
      text: {
        type: String
      },
      sizeBig: {
        type: Boolean,
        default: false
      }
    }
  },
  data () {
    return {
      items: [],
      renderComponent: true
    }
  },
  computed: {
    linksVisible: function () {
      return this.content.items.filter(elem => elem.visible)
    }
  },
  beforeDestroy () {
    eventBus.$off(DASHBOARD_FAST_LINKS)
  },
  methods: {
    go (action) {
      eventBus.$emit(DASHBOARD_FAST_LINKS, action)
    }
  }
}
</script>
<style lang="scss">
.quick-links-widget {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-bottom: 23px;

  .fast-link {
    display: flex;
    width: 50%;
    text-align: left;
    color: #7a7a7a;
    cursor: pointer;
    margin-top: 0.3em;

    &__icon {
      width: 16%;
      .icon-quick-links {
        width: 16px !important;
        height: 16px !important;
        min-height: 16px;
        min-width: 16px;
        margin: auto;
      }
      &--smaller {
        width: 10%;
      }
    }

    &__item {
      flex-shrink: 1;
      margin-top: 5px;

      h2 {
        font-family: Roboto, sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 15px;
        text-align: left;
        text-transform: uppercase;
        color: #7a7a7a;
        width: 100%;
        max-width: 128px;

        &:hover {
          color: #7f1a54;
        }
      }
    }
  }
}
</style>
